import { cn } from '@/utils/styles';

export interface HighlightedTextProps {
  text: string;
  highlight?: string;
  className?: string;
}

const HighlightedText = ({ text, highlight, className }: HighlightedTextProps) => {
  const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
  return (
    <span>
      {parts.map((part, i) => (
        <span
          key={i}
          className={cn(part.toLowerCase() === highlight?.toLowerCase() ? 'bg-lightBlue-200' : '', className)}
        >
          {part}
        </span>
      ))}
    </span>
  );
};

export { HighlightedText };
